import React from 'react';

import {AnimatedBackground} from 'components';
import {View} from 'containers';

import './style.scss';
import '../styles/style.scss';

const App = () => {
	return (
		<>
			<AnimatedBackground />
			<View />
		</>
	);
};

export default App;
